module.exports = __webpack_public_path__ + "static/img/hujiao.b9363ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/hujiao.png
// module id = Hza3
// module chunks = 24